import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { ThemeProvider as MuiThemeProvider } from "@mui/styles";
import React from "react";
import NotiSanckProvider from "./components/NotiSnackProvider";
import { renderRoutes } from "./routes";
import theme from "@/theme";
import Notistack from "@/components/Notistack";

function App() {
	return (
		<EmotionThemeProvider theme={theme}>
			<MuiThemeProvider theme={theme}>
				<div
					style={{
						// maxWidth: "2000px",
						minWidth: "1024px",
						margin: "0 auto",
					}}
				>
					<NotiSanckProvider>
						<Notistack />
						{renderRoutes()}
					</NotiSanckProvider>
				</div>
			</MuiThemeProvider>
		</EmotionThemeProvider>
	);
}

export default App;
